import { render, staticRenderFns } from "./jdjf.vue?vue&type=template&id=e0a0876c&scoped=true&"
import script from "./jdjf.vue?vue&type=script&lang=js&"
export * from "./jdjf.vue?vue&type=script&lang=js&"
import style0 from "./jdjf.vue?vue&type=style&index=0&id=e0a0876c&lang=less&scoped=true&"
import style1 from "./jdjf.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a0876c",
  null
  
)

export default component.exports